<div class="panel_wrapper">
  <div class="d-flex flex-column" style="gap: 10px;">
    <span class="add-comment-message">{{'RESERVATION.ADD_COMMENT_MESSAGE' | translate}}</span>
    <textarea rows="10" cols="50" class="dsc_text_area" [(ngModel)]="message"></textarea>
  </div>
  <div class="d-flex flex-row w-100 mt-4">
    <button class="btn_login w-50 m-0 me-2" (click)="close(true)">{{'RESERVATION.DECLINE' | translate}}</button>
    <button class="btn_without_color w-50 m-0"  style="line-height: 15px;"
            (click)="close(false)">{{'CANCEL' | translate}}</button>
  </div>
</div>
